/* Shim for the forked design editor: Brightivity has no feature tiers — every editor feature is on. */
export function useFeature() {
  return { hasFeature: () => true, features: null, loading: false };
}
export default null;
